import React from 'react';
import CommonDataTable from './commonTable';
import BookingDetails from '../OffCanvas/others/BookingDetails';
import { __jobStatus, __jobStatusDisplay } from '../../constants';
import { formatWithTZ } from '../../utils';

const Bookings = () => {
  const [canvasState, setCanvasState] = React.useState({
    open: false,
    userId: ""
  });

  const headers = [
    { label: "Status" },
    { label: "Booking No" },
    { label: "Booking description" },
    { label: "Customer" },
    { label: "Booking for" },
    { label: "Booked / Finalized on" },
    { label: "Provider" }
  ];

  const renderRow = (item, statusClassMap) => {
    return (
      <>
        <li style={{ overflow: "hidden", display: "flex" }}>
          <li className={`list_card_status ${statusClassMap[item.jobStatus] || ""}`}>
            {__jobStatusDisplay[item.jobStatus] || "Unknown"}
          </li>
        </li>
        <li>{item.displayedJobId || "NA"}</li>
        <li>{item.jobDescription || "NA"}</li>
        <li>{item.jobPostedBy.firstName} {item.jobPostedBy.lastName}</li>
        <li>{item.jobPostedFor || "NA"}</li>
        <li>
          {formatWithTZ(item.createdAt, "Do MMM, YYYY")} /{" "}
            {item.jobStatus === __jobStatus.finalized
             ? formatWithTZ(item.completedOn, "Do MMM, YYYY")
          : "--"}
        </li>
        <li>{item.applicationInfo?.firstName + " " + item.applicationInfo?.lastName}</li>
      </>
    );
  };

  const handleRowClick = (item, setCanvasState) => {
    setCanvasState({
      open: true,
      applicationId: item.applicationInfo._id,
      haveInvoice: [__jobStatus.finalized].includes(item.jobStatus)
    });
  };

  return (
    <CommonDataTable
      type="Booking"
      profileNavTitle="Bookings"
      headers={headers}
      renderRow={renderRow}
      onRowClick={handleRowClick}
      canvasComponent={BookingDetails}
      canvasState={canvasState}
      setCanvasState={setCanvasState}
      additionalParams={{}}
      customGridColumns="1.6fr 1fr 3fr 1.8fr 1.3fr 2.5fr 1.5fr 0.8fr"
    />
  );
};

export default Bookings;